import React from "react";
import { Button } from "@mui/material";
import { ShieldAlert } from "lucide-react";
import { useAppContext } from "context";
import { API, action, controller } from "api";
import { useTranslation } from "react-i18next";

// Shown when an authenticated user has no accessible module at all (e.g. a role
// with no permissions granted yet). Avoids dumping them on a raw 404.
const NoAccessPage = () => {
  const { t } = useTranslation();
  const { setAuthUser } = useAppContext();

  const handleLogout = () => {
    API(controller.Auth + action.Logout).get(() => setAuthUser());
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="flex flex-col items-center text-center max-w-md">
        <div
          className="flex items-center justify-center rounded-full mb-6"
          style={{ width: 90, height: 90, background: "var(--primaryXS-color)" }}
        >
          <ShieldAlert size={44} style={{ color: "var(--primary-color)" }} />
        </div>

        <h2 className="text-[22px] font-semibold text-gray-800 mb-2">
          {t("noAccessTitle", "No modules available")}
        </h2>

        <p className="text-[15px] text-gray-500 mb-8 leading-relaxed">
          {t(
            "noAccessBody",
            "Your account doesn't have access to any module yet. Please contact your administrator to be granted the access you need."
          )}
        </p>

        <Button
          variant="contained"
          onClick={handleLogout}
          sx={{
            backgroundColor: "var(--primary-color)",
            borderRadius: "12px",
            padding: "10px 32px",
            fontSize: "15px",
            fontWeight: 500,
            textTransform: "none",
          }}
        >
          {t("logout", "Sign out")}
        </Button>
      </div>
    </div>
  );
};

export default NoAccessPage;
